/**
 * Runner API cagrilari (session token ile).
 *
 * Sozlesme: docs/EcupRunner/02-session-runner-contract.md.
 * Skor SUNUCUDA hesaplanir; yanitlar skor/dogruluk bilgisi ICERMEZ.
 */
import { apiRequest } from "../api/client";
import type { MechanicAnswer, SessionItem } from "../mechanics/types";

/** GET /api/v4/runner/session yaniti. */
export interface RunnerSession {
  sessionCode: string;
  templateCode: string;
  displayName: string;
  status: "Active" | "Completed";
  items: SessionItem[];
}

export interface SubmitAnswerBody {
  /** Idempotency anahtari; ayni deger tekrar gelirse cift kayit olusmaz. */
  attemptId: string;
  /** Mekanige ozel cevap; sure asiminda { timedOut: true }. */
  answer: MechanicAnswer;
  durationMs: number;
}

export function getSession(token: string, signal?: AbortSignal): Promise<RunnerSession> {
  return apiRequest<RunnerSession>("/api/v4/runner/session", { method: "GET", token, signal });
}

export function submitAnswer(
  token: string,
  itemId: number,
  body: SubmitAnswerBody,
  signal?: AbortSignal,
): Promise<{ itemId: number; accepted: boolean }> {
  return apiRequest(`/api/v4/runner/items/${itemId}/answer`, {
    method: "POST",
    token,
    body,
    signal,
  });
}

export function finishSession(
  token: string,
  signal?: AbortSignal,
): Promise<{ sessionCode: string; status: string }> {
  return apiRequest("/api/v4/runner/finish", { method: "POST", token, signal });
}
